// extracted by mini-css-extract-plugin
export default {"verticalMarginSmall":"Divider_verticalMarginSmall__vC4Xi"};